import { FixedAspectRatioDiv } from '@rcm/fixed-aspect-ratio-div-react';
import { AddToCartPopupContainer } from 'block-multi-add-to-cart-client';
import type { CartProduct } from 'cart-core';
import type { BlockComponentProps } from 'client-react-block-renderer';
import { GtagCartUpdateMethod } from 'google-analytics';
import type { FormEvent } from 'react';
import React, { Component } from 'react';
import Modal from 'react-bootstrap-modal';
import MediaQuery from 'react-responsive';
import { DownloadVideo, PlayerIFrame } from 'vimeo-popup-player';
import CategoriesAccordion from './CategoriesAccordion';
import CategoriesWheel from './CategoriesWheel';
import CategoryHeader from './CategoryHeader';
import CategoryProducts from './CategoryProducts';
import './style.scss';
import type { Category, Config, Data } from './types';

interface Props extends BlockComponentProps<Data, Config> {}

interface State {
  categories: Category[];
  currentCategoryIndex?: number;
  currentProduct?: CartProduct;
}

export default class ProductCircleBlock extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const {
      config: { categories: categoriesC, centerCategory: centerCategoryC },
      data,
    } = props;
    // @todo: Update RCM block editor to provide data for newly-added blocks
    const categoriesD = (data && (data as Data).categories) || [];
    const centerCategoryD = (data && (data as Data).centerCategory) || null;
    const categories: Category[] = [
      { ...centerCategoryC, ...centerCategoryD },
      ...categoriesC.map((catC, i) => ({ ...catC, ...(categoriesD || [])[i] })),
    ];
    this.state = {
      categories,
      currentCategoryIndex: null,
      currentProduct: null,
    };
  }

  public handleClickCategory = (currentCategoryIndex: number) => this.setState({ currentCategoryIndex });

  public handleCloseCategory = () => this.setState({ currentCategoryIndex: null });

  public handleOpenProduct = (currentProduct: CartProduct) => this.setState({ currentProduct });

  public handleCloseProduct = (e?: FormEvent<HTMLElement>) => {
    // Make sure we only respond to click on the current target
    if (e && e.target !== e.currentTarget) {
      return;
    }
    this.setState({ currentProduct: null });
  };

  public render() {
    const {
      handleClickCategory,
      handleCloseCategory,
      handleOpenProduct,
      handleCloseProduct,
      props: { config },
      state: {
        categories,
        currentCategoryIndex,
        currentProduct,
        categories: { [currentCategoryIndex]: category, [currentCategoryIndex]: { video } = {} as any },
      },
    } = this;
    const vidRatio = video && video.width && video.height ? `${video.width}:${video.height}` : '16:9';
    return (
      <div className="product-circle-block">
        <MediaQuery minWidth={768}>
          {(isFullSize) => {
            const Renderer = isFullSize ? CategoriesWheel : CategoriesAccordion;
            return (
              <Renderer
                {...config}
                categories={categories}
                currentCategoryIndex={currentCategoryIndex}
                onOpenCategory={handleClickCategory}
                onCloseCategory={handleCloseCategory}
              >
                {category && (
                  <Modal
                    noBackdrop={true}
                    onClose={handleCloseCategory}
                    head={isFullSize && <CategoryHeader onClose={handleCloseCategory} category={category} />}
                    foot={<CategoryProducts category={category} onOpen={handleOpenProduct} />}
                  >
                    {!!(video && video.id) && (
                      <FixedAspectRatioDiv aspectRatio={vidRatio}>
                        <PlayerIFrame videoId={`${video.id}`} mode={'normal'} />
                      </FixedAspectRatioDiv>
                    )}
                    {!isFullSize && <DownloadVideo className="btn btn-link" video={video} />}
                  </Modal>
                )}
              </Renderer>
            );
          }}
        </MediaQuery>
        {currentProduct && (
          <AddToCartPopupContainer
            isOpen={true}
            onContinueShopping={handleCloseProduct}
            productId={currentProduct.productId}
            skuOptions={currentProduct.skuOptions}
            cart_update_method={GtagCartUpdateMethod.PRODUCT_CIRCLE_BLOCK}
          />
        )}
      </div>
    );
  }
}
